import { useContext } from 'react';

import { CurrentRequestContext } from '../context/CurrentRequestContext';

export const useCurrentRequest = () => useContext(CurrentRequestContext);
